import { Container } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from '../organisms/Footer'
import HomeHeader from '../organisms/HomeHeader'

const HomeLayout = () => {
	return (
		<Container maxWidth={false} disableGutters sx={{ overflowX: 'hidden' }}>
			<HomeHeader />
			<Outlet />
			<Footer />
		</Container>
	)
}

export default HomeLayout
